/**
 * Upstream model-provider unavailability (the PROVIDER's own quota/billing/capacity limits —
 * e.g. an exhausted Anthropic workspace budget — NOT the tenancy's configured AI usage limits).
 *
 * jms-api's stream relay classifies such failures mid-stream and rewrites the SSE error event to
 * carry this code with the generic copy below, so the raw provider error never reaches a client
 * and the chat can render a graceful notice instead of the generic stream error.
 */
export const AI_PROVIDER_UNAVAILABLE_CODE = 'AI_PROVIDER_UNAVAILABLE';

export const AI_PROVIDER_UNAVAILABLE_TITLE = 'AI is temporarily unavailable';

export const AI_PROVIDER_UNAVAILABLE_DETAIL = 'Something is limiting our AI service right now. Your conversation is safe — try again in a few minutes, and contact WorkBuddy support if it keeps happening.';
